import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getSwitchRolePath = () => urlHelper('/switch-role');
